import React from "react";
import { useTranslation } from "react-i18next";

import {
    Card,
    SectionHeader,
    CardTitle,
    LanguageItem,
    LanguageCodeBadge,
    LanguageLabelText,
    DefaultLanguageBadge,
    SocialToggle,
} from "./styled";
import { LANGUAGES } from "./types";

type LanguagesCardProps = {
    mainColor: string;
    enabledLanguages: Record<string, boolean>;
    defaultLanguage: string;
    onToggleLanguage: (code: string) => void;
    onSetDefaultLanguage: (code: string) => void;
};

export function LanguagesCard({
    mainColor,
    enabledLanguages,
    defaultLanguage,
    onToggleLanguage,
    onSetDefaultLanguage,
}: LanguagesCardProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <Card data-testid="scan-to-misc-languages-card">
            <SectionHeader>
                <CardTitle>{t("Languages")}</CardTitle>
            </SectionHeader>

            {LANGUAGES.map((lang) => {
                const isEnabled = enabledLanguages[lang.code];
                const isDefault = defaultLanguage === lang.code;
                return (
                    <LanguageItem key={lang.code} data-testid={`scan-to-misc-language-item-${lang.code}`}>
                        <LanguageCodeBadge enabled={isEnabled} mainColor={mainColor}>
                            {lang.code.toUpperCase()}
                        </LanguageCodeBadge>
                        <LanguageLabelText>{lang.label}</LanguageLabelText>
                        <DefaultLanguageBadge
                            data-testid={`scan-to-misc-language-default-btn-${lang.code}`}
                            isDefault={isDefault}
                            mainColor={mainColor}
                            onClick={() => onSetDefaultLanguage(lang.code)}
                            disabled={isDefault}
                        >
                            {isDefault ? t("Default") : t("Set as default")}
                        </DefaultLanguageBadge>
                        <SocialToggle
                            data-testid={`scan-to-misc-language-toggle-${lang.code}`}
                            isActive={isEnabled}
                            mainColor={mainColor}
                            onClick={() => onToggleLanguage(lang.code)}
                        />
                    </LanguageItem>
                );
            })}
        </Card>
    );
}
